import { useMutation } from '@tanstack/react-query';
import useAxios from 'hooks/useAxios';

import { EApiRoutes, getApiRouteOrMock } from './api.utils';

export const useCreateFirstProject = () => {
  const axios = useAxios();

  const initFirstProject = useMutation(
    async (data: {
      businessName: string;
      websiteUrl: string;
      country: string;
      countryCode3: string;
      teamSize: string;
      annualRevenue?: string;
      solutionModelSubtype?: string;
    }) => {
      return await axios.post(getApiRouteOrMock(EApiRoutes.INIT_PROJECT), data);
    },
    {}
  );

  return {
    initFirstProject
  };
};

